module.exports = __webpack_public_path__ + "static/media/paul_loading.b474d3b1.gif";